/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { Provider } from 'react-redux';
import './App.css';
import CartDetails from './components/CartDetails/CartDetails';
import Home from './components/Home/Home';
import Navbar from './components/Navbar';
import store from './redux/store';

function App() {
  const [showHomePage, setShowHomePage] = useState(true);
  const [showCartPage, setShowCartPage] = useState(false);

  return (
    <Provider store={store}>
      <Navbar
        setShowHomePage={setShowHomePage}
        setShowCartPage={setShowCartPage}
      />
      {showHomePage&&<Home/>}
      {showCartPage&&<CartDetails/>}
    </Provider>
  );
}

export default App;
